export default __webpack_public_path__ + "static/media/loader.a263bf17.svg";